module.exports = __webpack_public_path__ + "assets/images/4021b9cb9da586e26a730de9b28d4526.png";